import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="mt-1 mb-1 ">
      {vPathName === "/StockSetupChangeRequest" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Stock Setup Change Request{" "}
          </span>
        </div>
      ) : vPathName === "/StockSetupChangeRequestDetail" ? (
        <div className="d-flex align-items-center">
          {" "}
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/StockSetupChangeRequest"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Stock Setup Change Request{" "}
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Stock Setup Detail
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
